// extracted by mini-css-extract-plugin
export default {"wrapper":"index_wrapper__UNxV4","label":"index_label__Bj4Ra","label-text":"index_label-text__a+023","value":"index_value__q+Ikc"};